import { render } from "./TheBandSection.vue?vue&type=template&id=250c42f4&scoped=true"
import script from "./TheBandSection.vue?vue&type=script&lang=js"
export * from "./TheBandSection.vue?vue&type=script&lang=js"

import "./TheBandSection.vue?vue&type=style&index=0&id=250c42f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250c42f4"]])

export default __exports__